import { axios, Response } from '../index'

export type Body = {
  membersIds: string[]
}

const addMembers = (taskId: string, body: Body): Response<null> => {
  return axios.post(`/v1/tasks/${taskId}/members/`, body)
}

export default addMembers
